var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("fieldset", [
        _c("legend", { staticClass: "visually-hidden" }, [
          _vm._v(_vm._s(_vm.$t("common.formsSubTitle.gnrl"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "accordion-item accordionForm" }, [
          _c(
            "a",
            {
              staticClass: "item-content item-link",
              attrs: {
                href: "#",
                "aria-expanded": _vm.isGeneralSectionExpanded
                  ? "true"
                  : "false",
                "aria-controls": "general-section",
                role: "button",
              },
              on: {
                click: function ($event) {
                  return _vm.rotateChevron($event)
                },
              },
            },
            [
              _c("div", { staticClass: "item-inner" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group row justify-content-start styleGeneral",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "item-title createInvoiceBand col-sm-auto",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("common.formsSubTitle.gnrl")) +
                            "\n                "
                        ),
                        _c("i", { staticClass: "f7-icons formChevron" }, [
                          _vm._v("chevron_right"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "accordion-item-content",
              attrs: {
                id: "general-section",
                role: "region",
                "aria-labelledby": "general-heading",
              },
            },
            [
              _c(
                "div",
                { staticClass: "form-group d-flex justify-content-between" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      attrs: { for: "checkbox-pain001" },
                    },
                    [_vm._v(_vm._s(_vm.$t("settings.gnrt_bnk_trnsfr_ordr")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "label-switch ",
                      class: _vm.sliderColorClass,
                    },
                    [
                      _c("input", {
                        staticClass: "checkboxPain001",
                        attrs: {
                          id: "checkbox-pain001",
                          type: "checkbox",
                          disabled: _vm.canSwichPain001(),
                          "aria-describedby": _vm.canSwichPain001()
                            ? "pain001-disabled-info"
                            : null,
                        },
                        domProps: {
                          checked: _vm.settings.pain001 === "1",
                          value: _vm.settings.pain001,
                        },
                        on: { change: _vm.switchPain001 },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canSwichPain001()
                    ? _c(
                        "div",
                        {
                          staticClass: "visually-hidden",
                          attrs: { id: "pain001-disabled-info" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "accessibility.field_disabled_no_permission"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group d-flex justify-content-between" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label labelCheckbox",
                      attrs: { for: "checkbox-pacs008" },
                    },
                    [_vm._v(_vm._s(_vm.$t("settings.gnrt_instnt_pymnt")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "label-switch ",
                      class: _vm.sliderColorClass,
                    },
                    [
                      _c("input", {
                        staticClass: "checkboxPacs008",
                        attrs: {
                          id: "checkbox-pacs008",
                          type: "checkbox",
                          disabled: _vm.canSwitchPacs008(),
                          "aria-describedby": _vm.canSwitchPacs008()
                            ? "pacs008-disabled-info"
                            : null,
                        },
                        domProps: {
                          checked: _vm.settings.pacs008 === "1",
                          value: _vm.settings.pacs008,
                        },
                        on: { change: _vm.changeSwitchPacs008 },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canSwitchPacs008()
                    ? _c(
                        "div",
                        {
                          staticClass: "visually-hidden",
                          attrs: { id: "pacs008-disabled-info" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "accessibility.field_disabled_no_permission"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group d-flex justify-content-between" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      attrs: { for: "checkbox-decision-creancier" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("directPayments.dir_pymnt_decision_form"))
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "label-switch ",
                      class: _vm.sliderColorClass,
                    },
                    [
                      _c("input", {
                        staticClass: "checkboxDecisionCreancier",
                        attrs: {
                          id: "checkbox-decision-creancier",
                          type: "checkbox",
                          disabled: _vm.canSwitchCreditorDecision(),
                          "aria-describedby": _vm.canSwitchCreditorDecision()
                            ? "decision-disabled-info"
                            : null,
                        },
                        domProps: {
                          checked: _vm.settings.decision_creancier === "1",
                          value: _vm.settings.decision_creancier,
                        },
                        on: { change: _vm.changeSwitchDecisionCreancier },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canSwitchCreditorDecision()
                    ? _c(
                        "div",
                        {
                          staticClass: "visually-hidden",
                          attrs: { id: "decision-disabled-info" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "accessibility.field_disabled_no_permission"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group d-flex justify-content-between" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      attrs: { for: "checkbox-ocr-activation" },
                    },
                    [_vm._v(_vm._s(_vm.$t("settings.activate_OCR")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "label-switch",
                      class: _vm.sliderColorClass,
                    },
                    [
                      _c("input", {
                        staticClass: "checkboxOcrActivation",
                        attrs: {
                          id: "checkbox-ocr-activation",
                          type: "checkbox",
                          disabled: _vm.canSwitchOcrActivation(),
                          "aria-describedby": _vm.canSwitchOcrActivation()
                            ? "ocr-disabled-info"
                            : null,
                        },
                        domProps: {
                          checked: _vm.settings.ocrActivation === "1",
                          value: _vm.settings.ocrActivation,
                        },
                        on: { change: _vm.changeSwitchOcrActivation },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canSwitchOcrActivation()
                    ? _c(
                        "div",
                        {
                          staticClass: "visually-hidden",
                          attrs: { id: "ocr-disabled-info" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "accessibility.field_disabled_no_permission"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group d-flex justify-content-between" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      attrs: { for: "checkbox-email-rcv" },
                    },
                    [_vm._v(_vm._s(_vm.$t("settings.ntfy_rcvr_by_eml")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "label-switch ",
                      class: _vm.sliderColorClass,
                    },
                    [
                      _c("input", {
                        staticClass: "checkboxEmailRcv",
                        attrs: {
                          id: "checkbox-email-rcv",
                          type: "checkbox",
                          disabled: _vm.canSwitchEmailRcv(),
                          "aria-describedby": _vm.canSwitchEmailRcv()
                            ? "email-disabled-info"
                            : null,
                        },
                        domProps: {
                          checked: _vm.settings.emailForRcv === "1",
                          value: _vm.settings.emailForRcv,
                        },
                        on: { change: _vm.switchEmailRcv },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canSwitchEmailRcv()
                    ? _c(
                        "div",
                        {
                          staticClass: "visually-hidden",
                          attrs: { id: "email-disabled-info" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "accessibility.field_disabled_no_permission"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("fieldset", [
        _c("legend", { staticClass: "visually-hidden" }, [
          _vm._v(_vm._s(_vm.$t("common.formsSubTitle.othr"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "accordion-item accordionForm" }, [
          _c(
            "a",
            {
              staticClass: "item-content item-link",
              attrs: {
                href: "#",
                "aria-expanded": _vm.isOtherSectionExpanded ? "true" : "false",
                "aria-controls": "other-section",
                role: "button",
              },
              on: {
                click: function ($event) {
                  return _vm.rotateChevron($event)
                },
              },
            },
            [
              _c("div", { staticClass: "item-inner" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group row justify-content-start styleGeneral",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "item-title createInvoiceBand col-sm-auto",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("common.formsSubTitle.othr")) +
                            "\n                "
                        ),
                        _c("i", { staticClass: "f7-icons formChevron" }, [
                          _vm._v("chevron_right"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "accordion-item-content",
              attrs: {
                id: "other-section",
                role: "region",
                "aria-labelledby": "other-heading",
              },
            },
            [
              _c(
                "div",
                { staticClass: "form-group d-flex justify-content-between" },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-form-label",
                      attrs: { for: "checkbox-auto-accept" },
                    },
                    [_vm._v(_vm._s(_vm.$t("settings.allwys_accpt_dir_pymnts")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "label-switch ",
                      class: _vm.sliderColorClass,
                    },
                    [
                      _c("input", {
                        staticClass: "checkboxAutoAcceptPayment",
                        attrs: {
                          id: "checkbox-auto-accept",
                          type: "checkbox",
                          disabled: _vm.canSwitchAutoAcceptPayment(),
                          "aria-describedby": _vm.canSwitchAutoAcceptPayment()
                            ? "auto-accept-disabled-info"
                            : null,
                        },
                        domProps: {
                          checked: _vm.settings.auto_accept_payment === "1",
                          value: _vm.settings.auto_accept_payment,
                        },
                        on: { change: _vm.changeSwitchAutoAcceptPayment },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canSwitchAutoAcceptPayment()
                    ? _c(
                        "div",
                        {
                          staticClass: "visually-hidden",
                          attrs: { id: "auto-accept-disabled-info" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "accessibility.field_disabled_no_permission"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-form-label",
                    attrs: { for: "range-max-amount" },
                  },
                  [_vm._v(_vm._s(_vm.$t("settings.hghst_amnt")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { "aria-live": "polite" },
                  },
                  [_vm._v(_vm._s(_vm.settings.max_amount))]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.max_amount,
                      expression: "settings.max_amount",
                    },
                  ],
                  staticClass: "range-slider-streammind",
                  class: _vm.sliderColorClass,
                  attrs: {
                    id: "range-max-amount",
                    type: "range",
                    min: "0",
                    max: "150000",
                    value: "0",
                    step: "500",
                    disabled: _vm.canSwitchMaxAmount(),
                    "aria-describedby": _vm.canSwitchMaxAmount()
                      ? "max-amount-disabled-info"
                      : "max-amount-value",
                    "aria-label": "Montant maximum en euros",
                  },
                  domProps: { value: _vm.settings.max_amount },
                  on: {
                    __r: function ($event) {
                      return _vm.$set(
                        _vm.settings,
                        "max_amount",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _vm.canSwitchMaxAmount()
                  ? _c(
                      "div",
                      {
                        staticClass: "visually-hidden",
                        attrs: { id: "max-amount-disabled-info" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("accessibility.field_disabled_no_permission")
                          )
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "visually-hidden",
                    attrs: { id: "max-amount-value" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("accessibility.current_amount")) +
                        ": " +
                        _vm._s(_vm.settings.max_amount) +
                        " euros"
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "form-group justify-content-end mr-5" },
        [
          _c(
            "b-col",
            { attrs: { sm: "3" } },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "lg" },
                  on: { click: _vm.changeApplicationSettings },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }